module.exports = __webpack_public_path__ + "media/comment_ca_marche/dessinkdo-14fdfd89.png";